<template>
  <div class="demo">
    <div class="category all">
      <h2>全部分类</h2>
      <div class="left">
        <ul>
          <li v-for="(item,index) in list" @click="toCategoryshow(item.id)">
            <!-- <img :src="'http://www.itdks.com/'+item.icon_gray" alt=""> -->
            <img :src="item.icon_gray" @click="changeState(index)" alt="">
            <!-- <img :src="'http://itdks.com/'+item.icon_blue" @click="changeState(index)" alt=""> -->
            <p>{{ item.name }}</p>
          </li>
        </ul>
      </div>
      <div class="showall"  @click="showAll">
        <img src="./../../assets/img/top.png" alt="">
      </div>
    </div>
    <returnPre></returnPre>
  </div>
</template>

<script>
export default {
  name: "category",
  data() {
    return {
      list: [],
      dark: true,
      blue: false,
      part: true,
      dataList: []
    };
  },
  computed: {
    getId() {
      return this.$store.state.categoryId
      console.log(this.$store.state.categoryId)
    }
  },
  methods: {
    toCategoryshow(aid) {
      // 到达分类的播放页
      this.$router.push({
        name: "categorydetail",
        query: {
          id: aid
        }
      })
    },
    changeState(i) {
      this.$store.state.categoryId = i
      },
    showAll() {
      this.$router.push({
        name: "categorydetail"
      })
    }
  },
  created() {
    const that = this
    this.$axios.get("api/category/getCategory").then(res => {
      console.log('获取的值 ', res)
      // const dataArr = res.data.data.categoryList.slice(0, 12)
      const dataArr = res.data.data.categoryList
      dataArr.forEach(item=>{
        item.icon_blue = 'https://www.itdks.com/Public/Home/img/customer/category_icon/blue/' + item.icon_blue
        item.icon_gray = 'https://www.itdks.com/Public/Home/img/customer/category_icon/gray/' + item.icon_gray
        item.grayshow = true
        item.blueshow = false
      })
      that.list = dataArr
      console.log('list', that.list[0])
      that.dataList = dataArr
      // let result = res.data.data;
      // for (var i = 0; i < result.length; i++) {
      //   result[i].grayshow = true
      //   result[i].blueshow = false
      // }
      // this.List = result
    });
  },
  mounted() {
    this.getShareInfo()
  }
};
</script>

<style lang="less" scoped>
* {
  margin: 0;
  padding: 0;
}
body {
   background-color: #f2f6f2;
}
li {
  list-style: none;
}
.category {
  width: 750px;
  height: 200px;
  padding: 0px 0 0 48px;
  box-sizing: border-box;
  .left ul {
    width: 700px;
    display: flex;
    flex-wrap: wrap;
    li {
      width: 140px;
      height: 90px;
      display: inline-block;
      text-align: center;
      margin-right: 32px;
      margin-top: 26px;
      img {
        height: 35px;
      }
      p {
        font-size: 25px; /*px*/
        color: #bcbdba;
      }
    }
  }
}
.all {
  padding-top: 45px;
  h2 {
    font-size: 30px; /*px*/
    color: #bcbdba;
    font-weight: 400;
    height: 60px;
  }
}
.showall {
  width: 50px;
  height: 50px;
  position: fixed;
  top: 50px;
  right: 30px;
  // box-shadow: -2px 0 0 #000;
  border-left: 1px solid #bbb;
  img {
    width: 50px;
    height: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Commons/Category.vue